import React, { useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { motion } from 'framer-motion'
import { FaDiscord, FaUsers } from 'react-icons/fa'
import { message } from 'antd'

import { Container, Content, Title, Description, ServerGrid, JoinCommunity } from './styles'
import Item from './item'
import Loading from '../Loading'

import api from '../../services/api'

SwiperCore.use([Navigation, Pagination, Autoplay])

function PartnersSection() {
  const [loading, setLoading] = useState(true)
  const [servers, setServers] = useState([])
  const [error, setError] = useState(false)

  // We don't need to load servers anymore since we're not displaying them
  // useEffect(() => {
  //   async function loadServers() {
  //     try {
  //       const response = await api.get('/user/servers')
        
  //       if (response.data.servers.length > 0) {
  //         setServers(response.data.servers)
  //       }
        
  //       setLoading(false)
  //     } catch (err) {
  //       setError(true)
  //       setLoading(false)
  //     }
  //   }

  //   loadServers()
  // }, [])

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        when: 'beforeChildren',
      },
    },
  }

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.6 } },
  }

  return (
    <Container
      as={motion.div}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={containerVariants}
      style={{ padding: '3rem 2rem' }} // Reduced padding to minimize white space
    >
      <Content>
        {/* Partner servers section removed */}

        <JoinCommunity as={motion.div} variants={itemVariants} style={{ marginTop: 0 }}>
          <FaUsers className="icon" />
          <h3 style={{color: 'white'}}>Faça parte da nossa comunidade</h3>
          <p>Junte-se a outros servidores e compartilhe experiências com nossa tecnologia</p>
          <a 
            href="https://discord.gg/atlas" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <FaDiscord /> Entrar no Discord
          </a>
        </JoinCommunity>
      </Content>
    </Container>
  )
}

export default PartnersSection
